import React from 'react';
import './App.css';
import MaintenancePage from './components/MaintenancePage';

function App() {
  return <MaintenancePage />;
}

export default App;
